<template>
  <div class="q-edit-content">
    <vh-select v-if="value.ext.edit" v-model="value.detail.format">
      <vh-option
        v-for="item in formats"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </vh-option>
    </vh-select>
    <vh-date-picker
      v-if="!value.ext.edit && value.detail.format === 'Y-m-d'"
      v-model="val"
      @focus="focus"
      :disabled="isReplay"
      value-format="yyyy-MM-dd"
      :placeholder="$t('form.form_1046')"
      size="small"
      @click.native="Inputfocus"
      :picker-options="pickerOptions"
      ref="dataRef"
    >
    </vh-date-picker>
    <vh-time-picker
      v-if="!value.ext.edit && value.detail.format === 'H:i:s'"
      v-model="val"
      :disabled="isReplay"
      value-format="HH:mm:ss"
      @focus="focus"
      :placeholder="$t('form.form_1048')"
      size="small"
    >
    </vh-time-picker>
    <vh-date-picker
      v-if="!value.ext.edit && value.detail.format === 'Y-m-d H:i:s'"
      v-model="val"
      type="datetime"
      :disabled="isReplay"
      value-format="yyyy-MM-dd HH:mm:ss"
      @focus="focus"
      :placeholder="$t('form.form_1047')"
      size="small"
    >
    </vh-date-picker>
    <div v-if="!value.ext.edit && errorTip" class="error-msg">
      {{ errorTip }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    isReplay: Boolean,
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: (time) => {
          if (this.value.style === "birthday") {
            return time.getTime() > Date.now();
          }
          return false;
        },
      },
      val: "",
      formats: [
        {
          value: "Y-m-d",
          label: this.$t("quest.k_3401"),
        },
        {
          value: "H:i:s",
          label: this.$t("quest.k_3402"),
        },
        {
          value: "Y-m-d H:i:s",
          label: this.$t("quest.k_3403"),
        },
      ],
      errorTip: "",
    };
  },
  methods: {
    focus(e) {
      this.errorTip = "";
    },
    check() {
      if (this.value.required === "Y" && !this.val) {
        this.errorTip = this.$t("form.form_1083");
        return false;
      }
      return {id: this.value.id, value: this.val, style: this.value.style};
    },
    Inputfocus() {
      this.$refs.dataRef.blur();
    },
  },
  mounted() {
    //回显数据
    if (this.value.replayData) {
      this.val = this.value.replayData;
    }
  },
};
</script>

<style scoped lang="scss">
.q-edit-content {
  margin-top: 10px;
  ::v-deep {
    .error-msg {
      position: absolute;
      color: #fc5659;
      padding-left: 10px;
      line-height: 20px;
      font-size: 12px;
    }
  }
}
</style>
